module.exports =
{

  _init: function ()
  {
    console.log("init search.js")
    APPLICATION._APPLICATION.search($('.js-url'))
  }

}